module.exports = __webpack_public_path__ + "static/media/1_l_otboynik_19.27_93.8.58011251.png";